import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { SharedService } from '@services/shared.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="Loader-wrapper" *ngIf="isLoading | async" >
      <div class="loader-container">
        <div class="loader-ring"></div>
        <div class="loader-ring loader-ring-2"></div>
        <div class="loader-ring loader-ring-3"></div>
        <img src="assets/images/luqta_favicon1.png" alt="Loading" class="loader-logo" />
      </div>
    </div>
  `,
  styles: ``
})
export class LoaderComponent {

  isLoading!: any;
  constructor(private sharedService: SharedService) {
    this.isLoading = this.sharedService.loaderState;
  }
}
